import { Lightbulb, ShoppingBag, Globe, AlertTriangle } from 'lucide-react';

const TIP_ICONS = [ShoppingBag, Globe, AlertTriangle, Lightbulb];

export default function ShoppingTips({ tips }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {tips.map((tip, i) => {
        const Icon = TIP_ICONS[i % TIP_ICONS.length];
        return (
          <div
            key={tip.title}
            className="rounded-xl border border-slate-700/80 bg-gradient-to-br from-slate-800/50 to-slate-900/80 p-4"
          >
            <Icon className="w-5 h-5 text-emerald-500/90 mb-2" />
            <h3 className="text-sm font-semibold text-white mb-1">{tip.title}</h3>
            <p className="text-xs text-slate-400 leading-relaxed">{tip.text}</p>
          </div>
        );
      })}
    </div>
  );
}
